import { Language } from 'legacy/types/Language';

export const languageNames: { [key in Language]: string } = {
  en: 'English',
  it: 'Italian',
};
